// import logo from './logo.svg';
// import './App.css';
import './style.css';
import Header from './Header';
import Footer from './Footer';
import Home from './pages/home';
// import SaadaCourse from './pages/saadaCourse';
import EmpoweringWomen from './pages/empoweringWomen';


import { Container } from '@mui/material';
import { BrowserRouter as Router, Switch, Route, Routes, Link } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Header />
      <main className='App-main'>
      <Container className='centerMain'>
      <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/Saada" element={<SaadaCourse />} /> */}
          <Route path="/empowering-women" element={<EmpoweringWomen />} />
        </Routes>
      </Container>
      </main>
      <Footer />
    </div>

  );
}

export default App;
